import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum, ResourceTypeEnum } from 'src/shared/enums';
import { IChallengeCheckoutDonation } from 'src/shared/models';

const {
  CHECKOUT_DONATION_NAME,
  CHECKOUT_DONATION_IMAGE,
  CHECKOUT_DONATION_CARD_DESCRIPTION,
  CHECKOUT_DONATION_TERMS_LABEL,
  CHECKOUT_DONATION_TERMS_DOCUMENT,
  CHECKOUT_DONATION_PRODUCT,
} = ResourceTypeDetailEnum;

const { CHECKOUT_DONATION_POINTS } = ResourceTypeEnum;

export const buildChallengeCheckoutDonation = (
  resource: IResourceList
): IChallengeCheckoutDonation => {
  const {
    resourceDetailList,
    resourceList,
    name: title,
    idResource,
    score,
  } = resource;
  const challengePoints: number[] = [];
  let item: IChallengeCheckoutDonation;
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case CHECKOUT_DONATION_NAME:
          item = {
            ...item,
            buttonName: value,
          };
          break;
        case CHECKOUT_DONATION_IMAGE:
          item = {
            ...item,
            image: value,
          };
          break;
        case CHECKOUT_DONATION_TERMS_LABEL:
          item = { ...item, termsLabel: value };
          break;
        case CHECKOUT_DONATION_TERMS_DOCUMENT:
          item = { ...item, termsUrl: value };
          break;
        case CHECKOUT_DONATION_CARD_DESCRIPTION:
          item = { ...item, text: value };
          break;
      }
    });

  resourceList
    .filter(({ status }) => status)
    .forEach(({ idResourceType: { idResourceType }, resourceDetailList }) => {
      switch (idResourceType) {
        case CHECKOUT_DONATION_POINTS:
          resourceDetailList
            .filter(({ status }) => status)
            .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
              switch (idResourceTypeD) {
                case CHECKOUT_DONATION_PRODUCT:
                  challengePoints.push(parseInt(value));
                  break;
              }
            });
          break;
      }
    });

  return {
    ...item,
    title,
    idResource,
    points: score?.points || 0,
    donations: challengePoints,
  };
};
